import instanciaAxios from './InterceptorAxios';

const servicioLogeo = {
	buscarUsuario(usuario,contrasena) {
		return instanciaAxios.post('/autenticar?usuario='+usuario+'&contrasena='+contrasena);
	},

	autenticacion_invitado() {
		return instanciaAxios.post('/sinregistro/autenticar_invitado');
	},
	obtener_session_uuid() {
		return instanciaAxios.post('/sinregistro/identificador.json');
	}
}

export default servicioLogeo;